import React, { useEffect, useState } from "react";
import Layout from "../../../components/layout/layout";
import { SearchHeader } from "../../../components/seachHeader/SearchHeader";
import { ActivityItem } from "../../../common/Activity/CardView";
import { Pagination } from "../../../components/table/pagination";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import {
  calculateAvgReviewAndRating,
} from "../../../store/profileSlice";
// Replace profileSlice imports with activitySlice
import {
  fetchActivitiesByRole,
  updateActivityRatingAndReview,
  cleanupActivityListeners,
  initializeActivitySync,
} from "../../../store/slices/activitySlice";
import tooltipIcon from "../../../assets/icons/ActivityInfo.svg";
import { formatTimestamp } from "../../../utils/formatters";
import { Building2, Search } from "lucide-react";
import { db } from "../../../config/firebase";
import { doc, updateDoc, getDoc } from "firebase/firestore";

// Helper function to format duration from hours, minutes, seconds
const formatDuration = (
  hours: number,
  minutes: number,
  seconds: number
): string => {
  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  } else {
    return `${seconds}s`;
  }
};

import Modal from "../../../components/model/mode";
import NoActivity from "../../../assets/icons/no_activity.svg";

import { Loader, Pencil, X, HelpCircle, Clock } from "lucide-react";
import refund from "../../../assets/icons/Refund.svg";
import star from "../../../assets/icons/star.svg";
import userprofile from "../../../assets/image/user.png"; // Ensure this import exists
import { useAppState } from "../../../hooks/useAppState";
import { useAppSelector } from "../../../store/hooks";
import { getStateFullName } from "../../../common/AddressControl/stateNameMapper";
import { getCountryFullName } from "../../../common/AddressControl/countryNameMapper";

// Custom tooltip component
const Tooltip = ({ text, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {children}
      </div>
      {showTooltip && (
        <div className="absolute z-50 w-64 p-2 mt-2 text-sm text-[#696969] bg-[#FAFAFA] rounded-[8px] shadow-lg -left-28 top-full">
          {text}
        </div>
      )}
    </div>
  );
};
const getInitialsImage = (name: string) => {
  if (!name) return null;
  const initials = name
    .split(" ")
    .filter((part) => part.length > 0)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
  return (
    <div className="w-[65px] h-[65px] rounded-[13px] object-cover overflow-hidden bg-[#F15D18] flex items-center justify-center">
      <span className="text-white font-bold text-xl nunito-bold">
        {initials}
      </span>
    </div>
  );
};

let expertActivityCounter = 1;
const generateExpertActivityId = () => {
  const id = `E${String(expertActivityCounter).padStart(3, "0")}`; // Prefix "E" for Expert
  expertActivityCounter += 1; // Increment counter
  return id;
};

// Reusable loading component
const Loading = () => (
  <div className="h-[70vh] flex flex-col justify-center items-center">
    <Loader className="animate-spin text-[#F15D18] mb-3" size={32} />
    <p className="text-gray-500 text-lg nunito-medium">Loading activities...</p>
  </div>
);

// Reusable empty state component
const NoActivities = () => (
  <div className=" flex justify-center items-center mt-[14%]">
    <div className="flex flex-col items-center">
      <img src={NoActivity} alt="No Activity" className="h-64" />
      <p className="text-[#696969] text-[16px] nunito-regular mt-4">
        Nothing here yet, but that’s about to change! Start engaging - and watch
        this space come alive.
      </p>
    </div>
  </div>
);
const ExpertActivity = () => {
  const dispatch = useDispatch();
  
  // Replace profileSlice selector with activitySlice
  const { allActivities, loading: fetchLoading, error: fetchError } = useSelector(
    (state: RootState) => ({
      allActivities: state.activity.expertActivities || [],
      loading: state.activity.loading,
      error: state.activity.error,
    })
  );
  
  console.log(allActivities, "All Activities from Activity Store");

  // Replace orgData from Redux with local state for fetched orgData
  const [orgData, setOrgData] = useState<any>(null);
  console.log(orgData, "orgData");
  console.log(allActivities, "All Activities");
  const { user } = useAppState();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [loading, setLoading] = useState(false); // Filter state
  console.log("fetchLoading", loading);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [activeFilters, setActiveFilters] = useState({
    status: "",
    expertRating: "",
    customerRating: "",
    amountRanges: {
      range1: false,
      range2: false,
      range3: false,
      range4: false,
      range5: false,
      range6: false,
      custom: false,
      customMin: null,
      customMax: null,
    },
  });

  // New state variables for the modals
  const [activityView, setActivityView] = useState<boolean>(false);
  const [activityEditModel, setActivityEditModel] = useState<boolean>(false);
  const [viewData, setViewData] = useState<any>({});
  console.log(viewData, "viewData");
  // Activity details state variables
  const [activityTitle, setActivityTitle] = useState<string>("");
  const [activityName, setActivityName] = useState<string>("Activity Name");
  const [expertName, setExpertName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [expertRating, setExpertRating] = useState<string>("");
  const [expertReviewCount, setExpertReviewCount] = useState<string>("0");
  const [activityDate, setActivityDate] = useState<string>("");
  const [activityStartTime, setActivityStartTime] = useState<string>("");
  const [activityType, setActivityType] = useState<string>("");
  const [activityDuration, setActivityDuration] = useState<string>("");
  const [activityCost, setActivityCost] = useState<string>("");
  const [activitySavings, setActivitySavings] = useState<string>("0");

  // Edit activity data
  const [editActivityData, setEditActivityData] = useState({
    rating: 0,
    review: "",
  });

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [editOpen, setEditOpen] = useState<boolean>(false);
  const [selectedActivityId, setSelectedActivityId] = useState<string | null>(
    null
  );
  function formatRole(role) {
    switch (role) {
      case "customer_owner":
        return "Team Owner";
      case "customer_team_lead":
        return "Team Lead";
      case "customer_team_member":
        return "Team Member";
      default:
        return "Customer";
    }
  }
  const handleSearch = (value: string) => {
    setSearchTerm(value);
    setCurrentPage(1); // Reset to first page when searching
  };
  const handleFilter = (filters: any) => {
    console.log("Applied filters:", filters);
    // Handle null/undefined filters by resetting to default state
    if (!filters) {
      setActiveFilters({
        status: "",
        expertRating: "",
        customerRating: "",
        amountRanges: {
          range1: false,
          range2: false,
          range3: false,
          range4: false,
          range5: false,
          range6: false,
          custom: false,
          customMin: null,
          customMax: null,
        },
      });
    } else {
      // Ensure amountRanges exists with default values
      const safeFilters = {
        ...filters,
        amountRanges: filters.amountRanges || {
          range1: false,
          range2: false,
          range3: false,
          range4: false,
          range5: false,
          range6: false,
          custom: false,
          customMin: null,
          customMax: null,
        },
      };
      setActiveFilters(safeFilters);
    }
    setCurrentPage(1); // Reset to first page when filters change
  };

  // Format data for Expert tab
  const formatExpertActivities = (activities: any[]) => {
    return activities.map((activity) => {
      // Calculate duration from startTime and endTime if both exist
      let calculatedDuration = "";
      if (activity.startTime && activity.endTime) {
        const start = activity.startTime.seconds
          ? new Date(activity.startTime.seconds * 1000)
          : new Date(activity.startTime);

        const end = activity.endTime.seconds
          ? new Date(activity.endTime.seconds * 1000)
          : new Date(activity.endTime); // Calculate duration in milliseconds
        const durationMs = end.getTime() - start.getTime();

        // Convert to hours, minutes, seconds
        const hours = Math.floor(durationMs / (1000 * 60 * 60));
        const minutes = Math.floor(
          (durationMs % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((durationMs % (1000 * 60)) / 1000);

        // Format the duration string
        calculatedDuration = formatDuration(hours, minutes, seconds);
      } else if (activity.duration && typeof activity.duration === "object") {
        // Handle case where duration is passed as an object with hours, minutes, seconds
        const { hours = 0, minutes = 0, seconds = 0 } = activity.duration;
        calculatedDuration = formatDuration(
          Number(hours) || 0,
          Number(minutes) || 0,
          Number(seconds) || 0
        );
      }
      return {
        ...activity,
        activityId: activity.id || activity._id,
        name: activity?.metadata?.userName || activity?.userData?.displayName,
        email: activity?.metadata?.email || activity?.userData?.email,
        activityType: activity.type || "Video Call",
        duration:
          activity.duration && typeof activity.duration === "object"
            ? formatDuration(
                activity.duration.hours || 0,
                activity.duration.minutes || 0,
                activity.duration.seconds || 0
              )
            : calculatedDuration || "N/A",
        startTime: activity.startTime
          ? formatTimestamp(activity.startTime.seconds)
          : formatTimestamp(activity.timestamp?.seconds),
        profileImage:
          activity?.metadata?.profileImage || activity?.userData?.photoURL,
        ratings: activity?.metadata?.rating || activity?.ratings || "0",
        expertRating: activity?.expertRating || "0", // Expert's rating for the customer
        customerRating: activity?.customerRating || "0", // Customer's rating for the expert
        earnings: activity.cost
          ? `$${parseFloat(activity.cost).toFixed(2)}`
          : activity.metadata?.amount
          ? `$${parseFloat(activity.metadata.amount.replace("$", "")).toFixed(
              2
            )}`
          : "$0.00",
      };
    });
  };
  // Sort activities by date (most recent first)
  const sortActivitiesByDate = (activities: any[]) => {
    return [...activities].sort((a, b) => {
      // Try to extract date from various possible timestamp formats
      const getTimestamp = (activity: any) => {
        // First check for updatedAt as it's the most recent modification
        if (activity.updatedAt?.seconds) {
          return new Date(activity.updatedAt.seconds * 1000);
        } else if (activity.updatedAt instanceof Date) {
          return activity.updatedAt;
        } else if (typeof activity.updatedAt === "string") {
          return new Date(activity.updatedAt);
        }
        // Then check for endTime as it's typically later than startTime
        else if (activity.endTime?.seconds) {
          return new Date(activity.endTime.seconds * 1000);
        } else if (activity.endTime instanceof Date) {
          return activity.endTime;
        } else if (typeof activity.endTime === "string") {
          return new Date(activity.endTime);
        }
        // Then check for startTime
        else if (activity.startTime?.seconds) {
          return new Date(activity.startTime.seconds * 1000);
        } else if (typeof activity.startTime === "string") {
          return new Date(activity.startTime.split(",")[0]);
        }
        // Then check for timestamp
        else if (activity.timestamp?.seconds) {
          return new Date(activity.timestamp.seconds * 1000);
        } else if (activity.timestamp instanceof Date) {
          return activity.timestamp;
        } else if (typeof activity.timestamp === "string") {
          return new Date(activity.timestamp);
        }
        // Fallback to current date to avoid errors
        return new Date(0);
      };

      const timestampA = getTimestamp(a);
      const timestampB = getTimestamp(b);

      // Sort in descending order (newest first)
      return timestampB.getTime() - timestampA.getTime();
    });
  }; // Apply filters to the activities
  const applyFilters = (activities: any[]) => {
    return activities.filter((activity) => {
      // Apply search filter
      if (
        searchTerm &&
        !activity.name?.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !activity.email?.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !activity.activityId?.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        return false;
      }

      // Apply status filter
      if (activeFilters.status && activeFilters.status !== "") {
        if (activity.status !== activeFilters.status) {
          return false;
        }
      } // Apply expert rating filter (in expert activity, this is customer rating for expert)

      // Apply customer rating filter (customer rating for expert)
      if (activeFilters.customerRating && activeFilters.customerRating !== "") {
        const activityCustomerRating = activity.customerRating || "0";
        if (
          String(activityCustomerRating) !==
          String(activeFilters.customerRating)
        ) {
          return false;
        }
      }

      // Apply amount filters
      const cost = parseFloat(activity.earnings?.replace("$", "") || "0");

      // Check if any predefined amount range is selected
      const hasAmountFilter =
        activeFilters.amountRanges &&
        Object.entries(activeFilters.amountRanges)
          .filter(([key]) => key.startsWith("range"))
          .some(([_, value]) => value === true);

      // If any range is selected, check if this activity matches any selected range
      if (hasAmountFilter) {
        const inRange1 =
          activeFilters.amountRanges.range1 && cost >= 0 && cost <= 100;
        const inRange2 =
          activeFilters.amountRanges.range2 && cost >= 101 && cost <= 200;
        const inRange3 =
          activeFilters.amountRanges.range3 && cost >= 201 && cost <= 300;
        const inRange4 =
          activeFilters.amountRanges.range4 && cost >= 301 && cost <= 400;
        const inRange5 =
          activeFilters.amountRanges.range5 && cost >= 401 && cost <= 500;
        const inRange6 = activeFilters.amountRanges.range6 && cost >= 501;

        // If no selected range matches, exclude this activity
        if (
          !(
            inRange1 ||
            inRange2 ||
            inRange3 ||
            inRange4 ||
            inRange5 ||
            inRange6
          )
        ) {
          return false;
        }
      }

      // Apply custom amount range filter
      if (activeFilters.amountRanges?.custom) {
        const min = activeFilters.amountRanges.customMin;
        const max = activeFilters.amountRanges.customMax;

        // Check if the cost falls outside the custom range
        if ((min !== null && cost < min) || (max !== null && cost > max)) {
          return false;
        }
      }

      return true;
    });
  };

  console.log("Raw allActivities:", allActivities);

  const activitiesForFiltering = Array.isArray(allActivities)
    ? allActivities
    : [];
  // Use filtered data when search is active, otherwise use original data
  const filteredActivities = applyFilters(
    formatExpertActivities(
      activitiesForFiltering.filter(
        (activity: any) =>
          activity.type === "Video Call" ||
          activity.type === "Chat" ||
          activity.status === "completed" ||
          activity.status === "Issue reported" ||
          activity.status === "active"
      )
    )
  );
  console.log(filteredActivities, "Filtered Activities");
  // Sort the filtered activities by date
  const dataToDisplay = sortActivitiesByDate(filteredActivities);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(dataToDisplay.length / itemsPerPage);
  const startIndex = (currentPage - 1) * 6;
  const endIndex = startIndex + 6;
  const currentData = dataToDisplay.slice(startIndex, endIndex);
  const handleView = async (data: any) => {
    setViewData(data);
    setActivityTitle(data?.activityId || data?.id || "");
    setActivityName(data?.expertActivityName || "");
    setExpertName(data?.name || "");
    setEmail(data?.email || "");
    setExpertRating(data?.ratings || data?.expertRating || "");
    setActivityDate(data?.startTime?.split(",")[0] || "");
    setActivityStartTime(data?.startTime?.split(",")[1]?.trim() || "");
    setActivityType(data?.activityType || "Video Call");
    setActivityDuration(data?.duration || "");
    setActivityCost(
      data?.earnings?.replace("$", "") || data?.amount?.replace("$", "") || "0"
    );
    setActivitySavings(data?.refundAmount || "0.00");
    setSelectedActivityId(data?.activityId || data?.id || null); // Set selected

    // Fetch organization data from Firestore using customerOrganizationId
    if (data?.customerOrganizationId) {
      try {
        const orgRef = doc(db, "organizations", data.customerOrganizationId);
        const orgSnap = await getDoc(orgRef);
        if (orgSnap.exists()) {
          setOrgData(orgSnap.data());
        } else {
          setOrgData(null);
        }
      } catch (err) {
        setOrgData(null);
      }
    } else {
      setOrgData(null);
    }

    // Set the expert rating and review, and customer rating in viewData
    setViewData((prev: any) => ({
      ...prev,
      expertRating: data?.expertRating || data?.ratings || "0.0",
      expertReview: data?.expertReview || "",
      customerRating: data?.customerRating || 0,
      customerReview: data?.customerReview || "",
    }));

    // Set the review and rating in edit data
    if (data?.customerId) {
      const activities = allActivities.filter(
        (a: any) => a.customerId === data.customerId
      );
      const { avgRating, avgReview } = calculateAvgReviewAndRating(
        activities,
        data.customerId,
        "Customer"
      );
      setExpertRating(avgRating.toFixed(1));
      setExpertReviewCount(
        activities.filter((a: any) => a.customerReview).length
      );
    }

    setActivityView(true);
  };
  console.log(viewData, "View Data");

  const handleActivityClose = () => {
    setActivityView(false);
    setSelectedActivityId(null); // Remove selection highlight
    // Call the onModalClose callback if it exists
    if (viewData && viewData.onModalClose) {
      viewData.onModalClose();
    }
  };
  const handleOpenEditModal = () => {
    setActivityView(false);
    setEditActivityData({
      rating: parseFloat(viewData?.expertRating) || 0,
      review: viewData?.expertReview || "",
    });
    setActivityEditModel(true);
    setSelectedActivityId(viewData?.activityId || viewData?.id || null); // Set selected
  };
  const handleCloseEditModal = () => {
    setActivityEditModel(false);
    setSelectedActivityId(null); // Remove selection highlight
  };
  const handleRatingChange = (rating: number) => {
    setEditActivityData((prev) => ({
      ...prev,
      rating,
    }));
  };

  const handleReviewChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditActivityData((prev) => ({
      ...prev,
      review: e.target.value,
    }));
  };

  const handleSaveActivityEdit = async () => {
    try {
      setLoading(true);

      const activityId = viewData.id || viewData.activityId;
      if (!activityId) {
        throw new Error("Activity ID not found");
      }

      // Use activitySlice with immediate reflection for expert rating and review
      const result = await dispatch(
        updateActivityRatingAndReview({
          activityId,
          expertRating: editActivityData.rating, // For expert, this is their rating for the customer
          expertReview: editActivityData.review,  // For expert, this is their review for the customer
        })
      ) as any;

      if (result.type.endsWith('/fulfilled')) {
        // Update local view data
        const updatedViewData = {
          ...viewData,
          expertRating: editActivityData.rating,
          expertReview: editActivityData.review,
          updatedAt: new Date(),
        };
        setViewData(updatedViewData);

        // Close modal and show success
        setActivityEditModel(false);
        setActivityView(true);
        setLoading(false);
        alert("Your rating and review have been updated successfully!");
      } else {
        throw new Error("Failed to update rating and review");
      }
    } catch (error) {
      console.error("Error updating rating and review:", error);
      alert("Failed to update rating and review. Please try again later.");
      setLoading(false);
    }
  };

  const getActivityId = () => {
    return viewData?.activityId || viewData?.id || "";
  };
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setViewData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (user && user.uid) {
      // Initialize real-time activity sync for Expert
      dispatch(initializeActivitySync("Expert", user.uid));
    }

    // Cleanup listeners on unmount
    return () => {
      dispatch(cleanupActivityListeners());
    };
  }, [dispatch, user]);

  return (
    <Layout>
      {" "}
      <div
        className="p-6  mx-auto bg-white rounded-lg shadow-sm "
        style={{
          height: "calc(100vh - 112px)",
          overflowY: "hidden",
            overflowX:'hidden'
        }}
      >
        <SearchHeader
          title="My Activity"
          onSearch={handleSearch}
          onFilter={handleFilter}
          expertActivity={true}
        />
        <div className=" "  style={{
          height: "calc(80vh - 105px)",
          overflowY: "auto",
            overflowX:'hidden'
        }}>
          {loading ? (
            <Loading />
          ) : fetchError ? (
            <div className="text-red-500 text-center">{fetchError}</div>
          ) : currentData.length === 0 ? (
            searchTerm.trim() !== "" ||
            activeFilters.status !== "" ||
            activeFilters.expertRating !== "" ||
            activeFilters.customerRating !== "" ||
            Object.values(activeFilters.amountRanges || {}).some(Boolean) ? (
              <div className="flex flex-col items-center py-20">
                <div className="w-24 h-24 mb-4 flex items-center justify-center">
                  <Search className="w-16 h-16 text-gray-400" />
                </div>
                <h2 className="text-[24px] nunito-semibold text-[#404040] mb-2">
                  Opps! No matching records found.
                </h2>
                <p className="text-[#919191] text-[14px] nunito-semibold mb-4 text-center">
                  Try changing the filters or search criteria to see more
                  results!
                </p>
              </div>
            ) : (
              <NoActivities />
            )
          ) : (
            <>
              <div>
                {currentData.map((activity, index) => (
                  <ActivityItem
                    key={index}
                    data={activity}
                    handleView={handleView}
                    isSelected={
                      selectedActivityId ===
                      (activity.activityId || activity.id)
                    }
                  />
                ))}
              </div>
            </>
          )}

        </div>
              <div className="flex justify-center ">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              </div>
      </div>
          {/* New modal implementation */}
          <div
            className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
            style={{
              display: activityView || activityEditModel ? "flex" : "none",
            }}
          >
            {activityView ? (
              <div className="rounded-xl shadow-lg bg-white p-4  w-[530px] h-[677px] overflow-y-scroll  mx-auto relative">
                <div className="flex justify-between items-center mb-4">
                  <div className="flex items-center gap-2 text-[#0A0A0A] ">
                    <p className="text-[24px] nunito-semibold">Activity </p>
                    <p className="text-[20px] nunito-regular">
                      (#{activityName || activityTitle})
                    </p>
                  </div>
                  <button
                    className="p-1 rounded-md hover:bg-gray-100"
                    onClick={handleActivityClose}
                  >
                    <X size={24} />
                  </button>
                </div>

                <div className="flex gap-3 mb-3">
                  <div className=" border border-[#C4C4C4] rounded-[16px] p-2 w-full   h-[]">
                    <div className="flex gap-2">
                      <div className="mr-2">
                        {viewData?.profileImage ? (
                          <img
                            src={viewData?.profileImage}
                            alt="Customer profile"
                            className="w-[65px] h-[65px] rounded-[13px] object-cover"
                            style={{
                              boxShadow:
                                "0px 2px 4px 0px rgba(241, 93, 24, 0.25), 0px -2px 4px 0px rgba(241, 93, 24, 0.25), 2px 0px 4px 0px rgba(241, 93, 24, 0.25), -2px 0px 4px 0px rgba(241, 93, 24, 0.25)",
                            }}
                          />
                        ) : (
                          getInitialsImage(expertName)
                        )}
                        <span className="text-[14px] flex justify-center nunito-bold text-[#919191] ">
                          Customer
                        </span>
                      </div>

                      <div className="w-full">
                        <div className=" flex  items-center    justify-between ">
                          <div className=" items-center flex gap-2 ">
                            <span className="group relative">
                              <h3 className="text-[#0A0A0A] truncate max-w-36  text-[20px] nunito-semibold">
                                {expertName}
                              </h3>
                              {/* Tooltip on hover */}
                              <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-6  px-2 py-1 bg-[#FAFAFA] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                                <div className="text-start">
                                  <div className="nunito-regular text-[12px]  truncate text-[#696969] mb-1">
                                    {expertName}
                                  </div>
                                </div>
                              </div>
                            </span>

                            <span className="text-[#696969] text-[14px] flex truncate  nunito-medium">
                              ({formatRole(viewData?.customerData?.teamRole)})
                            </span>
                          </div>
                          <div className="flex   ml-5  ">
                            <span className="text-[#0A0A0A] text-[20px]  truncate max-w-32 nunito-semibold">
                              {orgData?.teamName || ""}
                            </span>
                          </div>
                        </div>
                        <div className="group relative">

                        <div className=" text-[#404040] truncate max-w-96 nunito-medium text-[14px] ml-1">
                          {email}
                        </div>
                           <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-5  px-2 py-1 bg-[#FAFAFA] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                                <div className="text-start">
                                  <div className="nunito-regular text-[12px]  truncate text-[#696969] mb-1">
                                    {email} 
                                  </div>
                                </div>
                              </div>
                        </div>
                        <div className="flex items-center ">
                          <img src={star} className="w-[20px] h-[20px]" />
                          <span className="text-[14px] nunito-regular text-[#696969]  ">
                            {expertRating} ({expertReviewCount} reviews)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* asana */}
                <div className="flex items-center mb-3 p-4 h-[116px] bg-white rounded-[16px] border border-[#C4C4C4] max-w-lg">
                  {/* Logo/Icon */}
                  <div className="mr-3">
                    <Building2 className="w-[80px] h-[80px] stroke-[0.5px] text-[#000000]" />
                  </div>

                  {/* Text Content */}
                  <div className="flex-grow">
                    <div className="flex justify-between items-start">
                      <h2 className="text-[20px] nunito-semibold text-[#0A0A0A]">
                        {orgData?.name || "-"}
                      </h2>
                      <div className="flex items-center text-[#404040] text-[12px]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-1"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                        <span>Tax ID: {orgData?.taxId || "N/A"}</span>
                      </div>
                    </div>
                    <div className=" ">
                      <p className="text-[14px] nunito-medium text-[#404040] mt-">
                        Website: {orgData?.url || " N/A"}
                      </p>
                      <p className="text-[14px] nunito-medium  text-[#404040] mt-">
                        Address: {orgData?.billingAddress?.address_1 || ""}
                        {orgData?.billingAddress?.address_2
                          ? "," + orgData.billingAddress.address_2
                          : ""}
                        {orgData?.billingAddress?.city
                          ? "," + orgData.billingAddress.city
                          : ""}
                        ,
                        {getStateFullName(
                          orgData?.billingAddress?.country || "",
                          orgData?.billingAddress?.state || ""
                        )}
                        ,
                        {getCountryFullName(
                          orgData?.billingAddress?.country || ""
                        )} 
                         {orgData?.billingAddress?.postcode
                          ? ", " + orgData.billingAddress.postcode
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="border border-[#C4C4C4] p-3 rounded-[16px]">
                  <div className="mb-6  ">
                    <div className="flex justify-between items-center mb-2">
                      <h3 className="nunito-semibold text-[16px] text-[#0A0A0A]">
                        Activity details
                      </h3>
                      <div className="flex items-center ">
                        <span className="mr-1 text-[#919191]">
                          <Clock className="w-[16px]  h-[16px]" />
                        </span>
                        <span className="text-[#404040] text-[14px] nunito-regular">
                          {activityDate}, {activityStartTime || "07:27:01 PM"}
                        </span>
                      </div>
                    </div>{" "}
                    <div className="grid grid-cols-3 gap-2 mb-4">
                      <div>
                        <div className="text-[#404040] mb-1 nunito-medium text-[16px]">
                          Activity Type
                        </div>
                        <div className="text-[#F15D18] nunito-bold text-[16px]">
                          {activityType}
                        </div>
                      </div>
                      <div>
                        <div className="text-[#404040] mb-1 nunito-medium text-[16px]">
                          Duration
                        </div>
                        <div className="text-[#F15D18] nunito-bold text-[16px]">
                          {activityDuration}
                        </div>
                      </div>

                      <div>
                        <div className="text-[#404040] mb-1 nunito-medium text-[16px]">
                          Earnings
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-[#F15D18] nunito-bold text-[16px]">
                            ${activityCost}
                          </span>
                          <span className="flex bg-orange-100 text-[#F15D18] rounded-full px-2 py-1 text-[14px]">
                            <img src={refund} className="w-[20px] h-[20px] " />$
                            {activitySavings}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="flex items-center mb-1">
                      <div className="nunito-semibold text-[16px] text-[#404040]">
                        Your Rating (for customer)
                      </div>
                      <Tooltip
                        text="Your feedback matters! 
                     You have 48 hours after the session
                      ends to rate and review. Then, once
                       time's up, it's locked in!"
                      >
                        <img
                          className="ml-1 w-[16px] h-[16px] "
                          src={tooltipIcon}
                        />
                      </Tooltip>
                    </div>{" "}
                    <div className="flex mb-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={`text-3xl ${
                            star <= (parseFloat(viewData.expertRating) || 0)
                              ? "text-orange-500"
                              : "text-gray-200"
                          }`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="mb-5">
                    <div className="flex items-center mb-1">
                      <div className="nunito-semibold text-[16px] text-[#404040]">
                        Your Review (for customer)
                      </div>
                      <Tooltip text="Your feedback matters! You have 48 hours after the session ends to rate and review. Then, once time's up, it's locked in!">
                        <img
                          className="ml-1 w-[16px] h-[16px] "
                          src={tooltipIcon}
                        />
                      </Tooltip>
                    </div>
                    <div className="flex justify-between items-center">
                      <p className="text-[#919191] text-[20px] nunito-medium">
                        "{viewData.expertReview || ""}"
                      </p>
                      <button
                        className="text-[#696969] hover:text-gray-700"
                        onClick={handleOpenEditModal}
                      >
                        <Pencil className="w-[24px] h-[24px]" />
                      </button>
                    </div>
                    <div className="border-t my-4 border-[#D9D9D9]"></div>
                  </div>{" "}
                  <div className="mb-4">
                    <div className=" mb-1 text-[16px] nunito-semibold text-[#404040]">
                      Customer Rating (for you)
                    </div>
                    <div className="flex mb-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={`text-3xl ${
                            star <= (parseFloat(viewData.customerRating) || 0)
                              ? "text-orange-500"
                              : "text-gray-200"
                          }`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </div>
                  <div>
                    <div className="nunito-semibold mb-1 text-[16px] text-[#404040]">
                      Customer Review (for you)
                    </div>
                    <p className="nunito-medium text-[20px] text-[#919191]">
                      " {viewData.customerReview} "
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              activityEditModel && (
                <div className="bg-white p-4 rounded-[24px] shadow-lg w-[448px]">
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-1">
                      <h2 className="text-[24px] nunito-semibold text-[#0A0A0A]">
                        Edit - Activity
                      </h2>
                      <h2 className="text-[24px] nunito-regular">
                        (#{getActivityId()})
                      </h2>
                    </div>
                    <button
                      className="text-[#404040] hover:text-gray-700"
                      onClick={handleCloseEditModal}
                    >
                      <X className="w-[32px] h-[32px]" />
                    </button>
                  </div>
                  <div className="p-3 px-7 ">
                    <div className="border border-[#D9D9D9] p-3 rounded-[16px]">
                      <div className="mb-4">
                        <p className="text-[16px] nunito-semibold text-[#404040]">
                          Your Rating (for customer)
                        </p>{" "}
                        <div className="flex space-x-1 mt-1">
                          {[1, 2, 3, 4, 5].map((star) => (
                            <span
                              key={star}
                              className={`text-3xl cursor-pointer ${
                                star <= editActivityData.rating
                                  ? "text-[#F15D18]"
                                  : "text-[#EBEBEB]"
                              }`}
                              onClick={() => handleRatingChange(star)}
                            >
                              ★
                            </span>
                          ))}
                        </div>
                      </div>
                      <div className="mb-2">
                        <p className="text-[16px] nunito-semibold text-[#404040]">
                          Your Review (for customer)
                        </p>
                        <input
                          type="text"
                          value={editActivityData.review}
                          onChange={handleReviewChange}
                          className="w-full mt-1 p-2 border-[1px] text-[14px] text-[#404040] border-[#404040] rounded-[6px]"
                          disabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center">
                    <button
                      className="w-[120px] h-[40px] bg-[#F15D18] text-[16px] nunito-bold hover:bg-orange-600  text-white py-2 rounded-[8px]"
                      onClick={handleSaveActivityEdit}
                      disabled={loading }
                    >
                      {loading ? (
                        <>
                          
                          Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              )
            )}
          </div>
    </Layout>
  );
};

export default ExpertActivity;
